import { useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { me, logout } from "../api";
import "./NavBar.css";
import logo from "../assets/LOGO - FOOTER.png";

export default function NavBar({ user: parentUser }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(parentUser || null);
  const [menuOpen, setMenuOpen] = useState(false); // menú móvil

  // Cargar usuario si no viene por props
  useEffect(() => {
    if (!parentUser) {
      me().then((r) => {
        if (r.user) setUser(r.user);
      });
    } else {
      setUser(parentUser);
    }
  }, [parentUser]);

  const roleHome = (role) =>
    role === "admin"
      ? "/admin"
      : role === "psicologa"
      ? "/psicologia"
      : role === "logopeda"
      ? "/logopedia"
      : role === "nutricionista"
      ? "/nutricion"
      : "/";

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  const linkClass = ({ isActive }) => `navlink ${isActive ? "active" : ""}`;

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to={roleHome(user?.role)}>
          <img src={logo} alt="TeAyudo" className="brand-logo" />
        </Link>

        {/* 🖥️ Links escritorio */}
        <div className="navbar-links desktop-only">
          {user?.role === "admin" && (
            <>
              <NavLink
                to="/admin"
                end
                className={({ isActive }) =>
                  `dashboard-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fa-solid fa-house" />
              </NavLink>
              <NavLink to="/admin/pacientes" className={linkClass}>
                Lista Pacientes
              </NavLink>
              <NavLink to="/admin/paciente" className={linkClass}>
                Nuevo Paciente
              </NavLink>
              <NavLink to="/admin/sesion" className={linkClass}>
                Agendar Sesión
              </NavLink>
              <NavLink to="/admin/calendario" className={linkClass}>
                Calendario
              </NavLink>
              <NavLink to="/admin/pagos" className={linkClass}>
                Pagos
              </NavLink>
              <NavLink
                to="/admin/usuarios"
                className={({ isActive }) =>
                  `dashboard-link ${isActive ? "active" : ""}`
                }
                title="Usuarios"
              >
                <i className="fa-solid fa-users" />
              </NavLink>
            </>
          )}

          {user?.role === "psicologa" && (
            <>
              <NavLink
                to="/psicologia"
                end
                className={({ isActive }) =>
                  `dashboard-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fa-solid fa-house" />
              </NavLink>
              <NavLink
                to="/psicologia/pacientes-psicologia"
                className={linkClass}
              >
                Mis Pacientes
              </NavLink>
              <NavLink to="/psicologia/calendario" className={linkClass}>
                Calendario
              </NavLink>
                <NavLink to="/psicologia/pagos" className={linkClass}>
                Pagos
              </NavLink>
            </>
          )}

          {user?.role === "logopeda" && (
            <>
              <NavLink
                to="/logopedia"
                end
                className={({ isActive }) =>
                  `dashboard-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fa-solid fa-house" />
              </NavLink>
              <NavLink
                to="/logopedia/pacientes-logopedia"
                className={linkClass}
              >
                Mis Pacientes
              </NavLink>
              <NavLink to="/logopedia/calendario" className={linkClass}>
                Calendario
              </NavLink>
              <NavLink to="/logopedia/pagos" className={linkClass}>
                Pagos
              </NavLink>
            </>
          )}

          {user?.role === "nutricionista" && (
            <>
              <NavLink
                to="/nutricion"
                end
                className={({ isActive }) =>
                  `dashboard-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fa-solid fa-house" />
              </NavLink>
              <NavLink
                to="/nutricion/pacientes-nutricion"
                className={linkClass}
              >
                Mis Pacientes
              </NavLink>
              <NavLink to="/nutricion/calendario" className={linkClass}>
                Calendario
              </NavLink>
              <NavLink to="/nutricion/pagos" className={linkClass}>
                Pagos
              </NavLink>
            </>
          )}

          <button
            className="google-auth-btn"
            onClick={() => navigate("/auth/drive")}
          >
            <i className="fa-solid fa-key"></i> Autenticar Google Drive
          </button>
        </div>

        {/* 🍔 Menú hamburguesa móvil */}
        <button
          className={`burger-btn mobile-only ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menú"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className="navbar-right">
        <span>{user?.email || user?.role || ""}</span>
        <button onClick={handleLogout} title="Salir">
          <i className="fa-solid fa-right-from-bracket" />
        </button>
      </div>

      {/* 📱 Menú móvil (roles incluidos) */}
      <div className={`mobile-menu ${menuOpen ? "show" : ""}`}>
        {user?.role === "admin" && (
          <>
            <NavLink to="/admin" onClick={() => setMenuOpen(false)}>
              Inicio
            </NavLink>
            <NavLink to="/admin/pacientes" onClick={() => setMenuOpen(false)}>
              Lista Pacientes
            </NavLink>
            <NavLink to="/admin/paciente" onClick={() => setMenuOpen(false)}>
              Nuevo Paciente
            </NavLink>
            <NavLink to="/admin/sesion" onClick={() => setMenuOpen(false)}>
              Agendar Sesión
            </NavLink>
            <NavLink to="/admin/calendario" onClick={() => setMenuOpen(false)}>
              Calendario
            </NavLink>
            <NavLink to="/admin/pagos" onClick={() => setMenuOpen(false)}>
              Pagos
            </NavLink>
            <NavLink
              to="/admin/usuarios"
              className={({ isActive }) =>
                `dashboard-link ${isActive ? "active" : ""}`
              }
              title="Usuarios"
            >
              <i className="fa-solid fa-users" />
            </NavLink>
          </>
        )}

        {user?.role === "psicologa" && (
          <>
            <NavLink to="/psicologia" onClick={() => setMenuOpen(false)}>
              Inicio
            </NavLink>
            <NavLink
              to="/psicologia/pacientes-psicologia"
              onClick={() => setMenuOpen(false)}
            >
              Mis Pacientes
            </NavLink>
            <NavLink
              to="/psicologia/calendario"
              onClick={() => setMenuOpen(false)}
            >
              Calendario
            </NavLink>
              <NavLink to="/psicologia/pagos" className={linkClass}>
                Pagos
              </NavLink>
          </>
        )}

        {user?.role === "logopeda" && (
          <>
            <NavLink to="/logopedia" onClick={() => setMenuOpen(false)}>
              Inicio
            </NavLink>
            <NavLink
              to="/logopedia/pacientes-logopedia"
              onClick={() => setMenuOpen(false)}
            >
              Mis Pacientes
            </NavLink>
            <NavLink
              to="/logopedia/calendario"
              onClick={() => setMenuOpen(false)}
            >
              Calendario
            </NavLink>
            <NavLink to="/logopedia/pagos" className={linkClass}>
              Pagos
            </NavLink>
          </>
        )}

        {user?.role === "nutricionista" && (
          <>
            <NavLink to="/nutricion" onClick={() => setMenuOpen(false)}>
              Inicio
            </NavLink>
            <NavLink
              to="/nutricion/pacientes-nutricion"
              onClick={() => setMenuOpen(false)}
            >
              Mis Pacientes
            </NavLink>
            <NavLink
              to="/nutricion/calendario"
              onClick={() => setMenuOpen(false)}
            >
              Calendario
            </NavLink>
            <NavLink to="/nutricion/pagos" className={linkClass}>
              Pagos
            </NavLink>
          </>
        )}

        <button
          className="google-auth-btn"
          onClick={() => {
            navigate("/auth/drive");
            setMenuOpen(false);
          }}
        >
          <i className="fa-solid fa-key"></i> Autenticar Google Drive
        </button>
      </div>
    </nav>
  );
}
